/**
 * Récupère tous les résultats d'une requête Strapi en gérant automatiquement la pagination
 * @param {string} collection - Le nom de la collection (ex: 'candidates')
 * @param {object} params - Les paramètres de la requête (sans pagination)
 * @param {Function} transformFn - Fonction optionnelle pour transformer chaque résultat (ex: candidate => candidate.id)
 * @param {number} initialLimit - Limite initiale pour la première requête (défaut: 150)
 * @returns {Promise<Array>} - Tous les résultats paginés
 */
export default async function findAll(collection, params = {}, transformFn = null, initialLimit = 150) {
  const { find } = useStrapi4()

  const allResults = []
  let start = 0
  let limit = initialLimit
  let total = null

  const firstRes = await find(collection, {
    ...params,
    pagination: { limit, start: 0 }
  })

  const firstResults = transformFn ? firstRes.data.map(transformFn) : firstRes.data
  allResults.push(...firstResults)

  limit = firstRes.meta.pagination.limit
  total = firstRes.meta.pagination.total
  if (allResults.length >= total) return allResults

  start = limit
  while (allResults.length < total) {
    const res = await find(collection, {
      ...params,
      pagination: { limit, start }
    })

    const results = transformFn ? res.data.map(transformFn) : res.data
    if (results.length === 0) break

    allResults.push(...results)
    start += limit

    if (allResults.length >= res.meta.pagination.total) break
  }

  return allResults
}
